import Marq from "react-fast-marquee";

const WORDS = ["Fresh", "Hot", "Made to Order", "Fire-Grilled", "Locally Sourced", "Craved Daily"];

export default function Marquee() {
  return (
    <section className="bg-cream py-10 md:py-16 border-y border-ink/10 overflow-hidden">
      <Marq speed={40} gradient={false} autoFill>
        <div className="flex items-center">
          {WORDS.map((w, i) => (
            <span key={i} className="font-serif-display text-outline text-6xl md:text-8xl px-8 whitespace-nowrap flex items-center gap-8">
              {w}<span className="text-terracotta text-3xl">✦</span>
            </span>
          ))}
        </div>
      </Marq>
    </section>
  );
}
